document.addEventListener("DOMContentLoaded", function () {

  
  var iframe = document.querySelector("#three-iframe");
  var header = document.querySelector("header");
  var footer = document.querySelector("footer");
  var video = document.querySelector('.object-cover')
  var main = document.querySelector('main')
 
    window.addEventListener('message', function(event) {
        console.log("footer")

        if (event.origin !== 'https://hoodie-khaki.vercel.app') {
            console.warn('Origin mismatch:', event.origin);
            // return;
        }

        // Handle the data received from the iframe
        var data = event.data;
        console.log('Data received from iframe:', data);

        if (data.path) {
            window.location.href = data.path;
        }
    });

  if (window.location.pathname === "/pages/experience" || window.location.pathname === "/en/pages/experience") {
    header.style.display = "none";
    footer.style.display = "none";
    main.style.padding = 0
    
    document.querySelector(".container").classList.remove("container");
    document.querySelector(".container").classList.remove("container");
    document.documentElement.style.setProperty('--section-without-border-vertical-spacing', '0');

  } else {
    header.style.display = "block";
    footer.style.display = "block";
  }
  if(window.location.pathname === '/'){
    footer.style.display = "none";
  }

  // Product Page Tabs
  const tabset = document.querySelector('.product-info__block-item .station-tabs-tabset');

  console.log(tabset)
  if(tabset){
    while (tabset.children.length > 3) {
      tabset.removeChild(tabset.lastElementChild);
    }
  }


const element = document.querySelector('[data-slug="details"]:not(.mod-first)');
  if (element && element.parentElement) {
    element.parentElement.style.display = "none";
  }
});


var lastScrollTop; 
var navbar = document.querySelector('product-sticky-bar')
const btn = document.querySelector('.shopify-payment-button')

// if(navbar){
// window.addEventListener('scroll', function() {
//   if(btn.getClientRects()[0].top < 140 && navbar){
//       navbar.classList.add('is-visible')
//   }else if(navbar){
//       navbar.classList.remove('is-visible')
//   }
// });
// }

